import watchBand from '@/assets/device-icons/watch-band.svg';

interface WatchBandIconProps {
  className?: string;
}

export const WatchBandIcon = ({ className = "h-5 w-5" }: WatchBandIconProps) => {
  return (
    <img 
      src={watchBand} 
      alt="Watch Band" 
      className={className}
    />
  );
};
